(function () {
  /**
   * @ngdoc module
   * @name akitabox.ui.components.reportingCharts.workPerformedByChart
   *
   * @param {Object} building - building to build the chart with
   */
  angular
    .module("akitabox.ui.components.reportingCharts.workPerformedByChart", [
      "akitabox.constants",
      "akitabox.core.services.chart",
      "akitabox.core.services.flag",
      "akitabox.ui.directives.stackChart",
      "akitabox.core.services.organization",
    ])
    .component("abxWorkPerformedByChart", {
      bindings: {
        buildings: "<abxBuildings",
        startDate: "<abxStartDate",
        endDate: "<abxEndDate",
        filters: "<abxFilters",
      },
      controller: AbxWorkPerformedByController,
      controllerAs: "vm",
      templateUrl:
        "app/core/ui/components/reporting-charts/work-performed-by-chart/work-performed-by-chart.component.html",
    });
  function AbxWorkPerformedByController(
    // Angular
    $log,
    $timeout,
    // Constants
    models,
    MINIMUM_RENDER_DELAY,
    // Services
    BuildingService,
    ChartService,
    ShadowService,
    OrganizationService
  ) {
    var self = this;
    var config = {};

    var GA_CATEGORY = "reporting";
    var organization = OrganizationService.getCurrent();

    // Attributes
    self.idTag = "work-performed-by-chart";
    self.data = [];
    self.groupKey = "_id";
    self.loading = true;
    self.showChart = false;
    self.nullValue = "Unassigned";
    self.hoverLabel = models.WORK_ORDER.PLURAL;

    self.yAxisOptions = [
      "# Completed",
      "# Open",
      "# Overdue",
      "# Scheduled",
      "Avg. Duration (Days)",
      "Cost",
      "Hours Logged",
    ];
    self.disabledStackOptions = [];
    self.activeYAxisOption = self.yAxisOptions[0];
    self.stackOptions = [];
    self.selectedStack = "---";
    self.excludeStackOptions = ["Assignee", "Work Performed By"];
    if (!organization.show_time_codes) {
      self.excludeStackOptions.push("Time Code");
    }
    self.hoverLabel = "";
    self.defaultStackOption = {
      model: "---",
      value: "---",
    };

    self.onYAxisChange = onYAxisChange;
    self.onStackChange = onStackChange;
    self.onStackHover = onStackHover;
    self.onRedirect = onRedirect;

    // ------------------------
    //   Life Cycle
    // ------------------------

    self.$onInit = function () {
      if (!self.buildings || self.buildings.length === 0) {
        $log.error("abxAssignee: abx-buildings is required");
        return;
      }

      updateDisabledStackOptions("");
    };

    self.$onChanges = function (changes) {
      if (changes.buildings) {
        config = ChartService.getChartConfig(
          self.buildings,
          models.WORK_ORDER.MODEL
        );
        self.stackOptions = ChartService.getStackOptions(
          models.WORK_ORDER.MODEL,
          self.buildings.length > 1,
          ["Age"],
          self.excludeStackOptions
        );
      }
      if (changes.startDate || changes.endDate) {
        self.yAxisFilterOptions = ChartService.getYAxisConfig(
          self.yAxisOptions,
          self.startDate,
          self.endDate
        );
        self.yAxisConfig = self.yAxisFilterOptions[self.activeYAxisOption];
        self.hoverLabel = self.yAxisConfig.label;
      }
      if (changes.filters) {
        updateFilters(self.yAxisConfig.lookupModel);
      }
      if (
        changes.startDate ||
        changes.endDate ||
        changes.filters ||
        changes.buildings
      ) {
        calculateStats();
      }
    };

    // ------------------------
    //   Events
    // ------------------------

    // ------------------------
    //   Public Functions
    // ------------------------

    function onStackHover($event) {
      self.highlightedStack = $event.value;
    }

    function onStackChange($event) {
      ShadowService.setSelectedOption($event.value);
      ShadowService.sendEvent(GA_CATEGORY, "switch-stack-by", self.idTag);
      self.selectedStack = $event.model;
      updateFilters(self.yAxisConfig.lookupModel);
      calculateStats();
    }

    function onYAxisChange($event) {
      ShadowService.setSelectedOption($event.value);
      ShadowService.sendEvent(GA_CATEGORY, "switch-y-axis", self.idTag);
      self.activeYAxisOption = $event.model;
      self.yAxisConfig = self.yAxisFilterOptions[self.activeYAxisOption];
      self.hoverLabel = self.yAxisConfig.label;
      updateFilters(self.yAxisConfig.lookupModel);
      updateDisabledStackOptions(self.yAxisConfig.label);

      if (
        self.activeYAxisOption === "Cost" ||
        self.activeYAxisOption === "Hours Logged"
      ) {
        /**
         * reset the selected stack by option if user choses a combintion of Cost|Logged Hours
         * with Age as a stack
         * We don't do this stats calculation on our back-end currently
         */
        self.stackOptions = ChartService.getStackOptions(
          models.WORK_ORDER.MODEL,
          self.buildings.length > 1,
          null,
          self.excludeStackOptions
        );
        if (self.selectedStack === "Age") {
          onStackChange(self.defaultStackOption);
        }
      } else {
        self.stackOptions = ChartService.getStackOptions(
          models.WORK_ORDER.MODEL,
          self.buildings.length > 1,
          ["Age"],
          self.excludeStackOptions
        );
      }

      calculateStats();
    }

    // ------------------------
    //   Private Functions
    // ------------------------

    function setShowChart() {
      var options = {
        startDate: self.startDate,
        endDate: self.endDate,
        yAxis: self.activeYAxisOption,
      };
      self.showChart = ChartService.shouldShowChart(
        models.WORK_ORDER.MODEL,
        ChartService.CHART_TYPE_BAR,
        self.data,
        options
      );
    }

    function onRedirect(worker) {
      var currentBuilding = BuildingService.getCurrent();
      // build redirect url params
      if (!Object.keys(self.identitiesMap).length) return;
      var identity = self.identitiesMap[worker.name];
      // filter by work performed by (identity id)
      var redirectParams = "tasks?workers=" + identity;
      if (currentBuilding) {
        redirectParams = redirectParams.concat(
          "&building=" + currentBuilding._id || currentBuilding
        );
      }
      // if it's a valid status
      if (self.yAxisFilterOptions[self.activeYAxisOption].params.status) {
        // filter by status
        redirectParams = redirectParams.concat(
          "&status=" +
            self.yAxisFilterOptions[self.activeYAxisOption].params.status
        );
      }

      switch (self.activeYAxisOption) {
        case "# Completed":
        case "Avg. Duration (Days)":
          redirectParams = redirectParams.concat(
            "&completed_date=$gte," +
              self.startDate.valueOf() +
              ",$lte," +
              self.endDate.valueOf()
          );
          break;
        case "# Open":
        case "# Scheduled":
          redirectParams = redirectParams.concat(
            "&start_date=$gte," +
              self.startDate.valueOf() +
              ",$lte," +
              self.endDate.valueOf()
          );
          break;
        case "# Overdue":
          redirectParams = redirectParams.concat(
            "&start_date=$gte," +
              self.startDate.valueOf() +
              ",$lte," +
              self.endDate.valueOf() +
              "&due_date=$lte," +
              self.endDate.valueOf()
          );
          break;
      }

      if (
        self.activeYAxisOption !== "Cost" &&
        self.activeYAxisOption !== "Hours Logged"
      ) {
        window.location.href = redirectParams;
      }
    }

    /**
     * Calculate the workOrder stats for the given date
     */
    function calculateStats() {
      if (
        self.startDate.toString() === "Invalid Date" ||
        self.endDate.toString() === "Invalid Date"
      )
        return;
      self.loading = true;
      self.showChart = false;
      var params;
      // model to append in the lookup stage
      var lookupModel;
      // model to use for the stats function
      var modelName;
      if (self.yAxisConfig && self.yAxisConfig.lookupModel) {
        lookupModel = self.yAxisConfig.lookupModel;
        modelName = self.yAxisConfig.overrideModel;
        params = {
          group_field: "user._id",
          lookup_field: [lookupModel, "work_performed_by_user"],
          unwind_field: "work_performed_by_user",
          unwind_lookup: true,
        };
        // to avoid issues with angular.extend overriding
        delete self.filters.lookup_field;
      } else {
        modelName = models.WORK_ORDER.MODEL;
        params = {
          group_field: "identity._id",
          unwind_field: "workers",
          unwind_lookup: true,
        };
      }

      config = ChartService.getChartConfig(self.buildings, modelName);

      params = angular.extend(params, self.filters, self.yAxisConfig.params);

      if (config.buildingInString) params.buildings = config.buildingInString;

      config
        .statsFunction(config.parentId, params)
        .then(function (results) {
          if (self.yAxisConfig && self.yAxisConfig.lookupModel) {
            self.users = results.map((u) => u._id);
            return ChartService.updateUserDisplayNames(
              results,
              self.buildings
            ).then(function (results) {
              self.usersMap = {};
              for (var i = 0; i < results.length; i++) {
                self.usersMap[results[i]._id] = self.users[i];
              }
              return results;
            });
          }
          self.identities = results.map((i) => i._id);
          return ChartService.updateIdentityDisplayNames(
            results,
            self.buildings
          ).then(function (results) {
            self.identitiesMap = {};
            for (var i = 0; i < results.length; i++) {
              self.identitiesMap[results[i]._id] = self.identities[i];
            }
            return results;
          });
        })
        .then(function (data) {
          self.legendValues = [];

          ChartService.addEmptyBars(data, self.filters.assignee_email);
          if (!params.stack_field) {
            self.data = self.yAxisConfig.transform(data);
            return;
          }

          if (params.stack_field === "intent") {
            self.stackSort = ChartService.sortIntent;
          } else if (params.stack_field === "age_group") {
            self.stackSort = ChartService.sortAge;
          } else {
            self.stackSort = undefined; // sort function must either be undefined or function
          }

          return ChartService.parseStackData(
            data,
            params.stack_field,
            params.stack_field === "building" ? config.buildingMap : null,
            self.yAxisConfig.transform,
            self.buildings
          );
        })
        .then(function (stackData) {
          if (!stackData) {
            // no stack_field provided, self.data is already set above
            return;
          }
          if (params.stack_field === "time_code") {
            self.legendValues = ChartService.filterTimeCodeLabel(
              stackData.keys
            ).sort();
            self.data = ChartService.transformTimeCodeData(stackData.data);
          } else {
            self.legendValues = stackData.keys.sort(self.stackSort);
            self.data = stackData.data;
          }
        })
        .then(function () {
          return $timeout(angular.noop, MINIMUM_RENDER_DELAY);
        })
        .finally(function () {
          self.loading = false;
          setShowChart();
        });
    }

    /**
     *
     * @param {String} lookupModel model to prepend to the name of the stack filter
     */

    function updateFilters(lookupModel) {
      self.filters = ChartService.updateStackFilter(
        self.selectedStack,
        self.filters,
        lookupModel
      );
    }

    /**
     * Disable certain stack options based on the currently selected
     * y-axis option
     *
     * @param {String} yAxisLabel name of the current y-axis config
     */
    function updateDisabledStackOptions(yAxisLabel) {
      self.disabledStackOptions = [];
      if (yAxisLabel !== "Hours Logged") {
        self.disabledStackOptions.push("Time Code");
        if (self.selectedStack === "Time Code") {
          self.onStackChange(self.defaultStackOption);
        }
      }
    }
  }
})();
